import React from 'react';
import styled from 'styled-components';
import { MotifButton } from '@ey-xd/motif-react';
import { useNavigate } from 'react-router-dom';
import { LOGOUT_SCREEN } from '../../../constants/commonConstants';
import { Container, FullScreenContainer, Header, Text, Title } from './styles/logOutscreenStyles';

const LogOutScreen = () => {
  const navigate = useNavigate();

  const handleRestart = () => {
    navigate('/');
    window.location.reload();
  };

  return (
    <FullScreenContainer>
      <Container>
        <Header>
          <Title>{LOGOUT_SCREEN.HEADER_TITLE}</Title>
          <Text>{LOGOUT_SCREEN.DESCRIPTION}</Text>
        </Header>
        <MotifButton variant="primary-alt" onClick={handleRestart}>
          {LOGOUT_SCREEN.BUTTON_TITLE}
        </MotifButton>
      </Container>
    </FullScreenContainer>
  );
};

export default LogOutScreen;
